import {
  IRequirementResponse,
  RequirementStatus,
  RequirementType
} from "@wingspanhq/payments/dist/interfaces";
import { ListRequestQuery } from "../../utils/serviceHelper";
import { servicePayments } from "../servicePayments";
import { DataSourceType } from "@wingspanhq/payments/dist/interfaces/requirement";

export interface RequirementsListFilter {
  payerId?: string;
  payeeId?: string;

  payerPayeeEngagementIds?:
    | string
    | string[]
    | {
        "="?: string;
        "!="?: string;
        in?: string[];
      };

  requirementDefinitionId?: string;

  dataSourceId?: string;
  dataSourceType?:
    | DataSourceType
    | DataSourceType[]
    | {
        "="?: DataSourceType;
        in?: DataSourceType[];
        "!="?: DataSourceType;
      };

  "dataSourceMetadata.status"?:
    | string
    | {
        "="?: string;
        "!="?: string;
        in?: string[];
      };

  // Status filters
  status?:
    | RequirementStatus
    | RequirementStatus[]
    | {
        "="?: RequirementStatus;
        in?: RequirementStatus[];
      };

  payerOverrideStatus?:
    | RequirementStatus
    | {
        "="?: RequirementStatus;
        in?: RequirementStatus[];
      };

  // Type categorization
  requirementType?:
    | RequirementType
    | RequirementType[]
    | {
        "="?: RequirementType;
        in?: RequirementType[];
      };

  // Date range filtering
  effectiveDate?: {
    [key in "=" | ">" | ">=" | "<" | "<="]?: Date;
  };

  expirationDate?: {
    [key in "=" | ">" | ">=" | "<" | "<="]?: Date;
  };

  // Audit timestamp filtering
  createdAt?: {
    [key in "=" | ">" | ">=" | "<" | "<="]?: Date;
  };

  updatedAt?: {
    [key in "=" | ">" | ">=" | "<" | "<="]?: Date;
  };
}

export type RequirementListResponse = {
  data: IRequirementResponse[];
  summary: {
    listSize: number;
  };
};

export type RequirementsListQuery = ListRequestQuery<
  RequirementsListFilter,
  {
    createdAt?: "asc" | "desc";
    updatedAt?: "asc" | "desc";
    effectiveDate?: "asc" | "desc";
    expirationDate?: "asc" | "desc";
  }
>;

export const listRequirements = async (
  params?: RequirementsListQuery
): Promise<RequirementListResponse> => {
  const { data, headers } = await servicePayments.get(`/requirement`, {
    params
  });

  return { summary: { listSize: Number(headers["x-ws-list-size"]) }, data };
};
